<div class="modal-header" id="start-work-modal-title">
    <h3 class="modal-title" translate="FREQUENT_ACTIVITIES_BUTTON_START_WORK_LABEL"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    @if (model.endOfWork) {
        <div class="row">
            <div class="col-5">
                <label translate="START_WORK_END_OF_WORK_LABEL"></label>
            </div>
            <div class="col-4">
                <span data-testid="textEndOfWorkDate">{{ model.endOfWorkDate }}</span>
            </div>
            <div class="col-3">
                <span data-testid="textEndOfWorkTime">{{ model.endOfWorkTime }}</span>
            </div>
        </div>
    }
    @if (!model.endOfWork) {
        <div class="row">
            <span class="col-12" translate="START_WORK_ERROR_EMPTY_END_OF_WORK_MESSAGE"></span>
        </div>
    }
    <div class="row">
        <div class="col-5">
            <label translate="START_WORK_START_OF_WORK_LABEL"></label>
        </div>
        <div class="col-4">
            <span data-testid="textStartOfWorkDate">{{ model.startOfWorkDate }}</span>
        </div>
        <div class="col-3">
            <span data-testid="textStartOfWorkTime">{{ model.startOfWorkTime }}</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        type="button"
        (click)="saveStartWork()"
        translate="START_WORK_BUTTON_SAVE_START_WORK_LABEL"
    ></button>
</div>
